import { useContext, useState } from 'react';
import classNames from 'classnames';
import { TenantContext } from '../../../context/tenant-context';

export const ProductImageV2 = ({
  productId,
  profile,
  className,
  href,
  alt,
}: {
  productId: number | 'placeholder';
  profile: 'MINI' | 'THUMB' | 'MEDIUM' | 'APP' | 'LARGE' | 'ORIGINAL' | undefined;
  className?: string;
  href?: string;
  alt?: string;
}) => {
  const { tenant } = useContext(TenantContext);
  const bucketEnv =
    window.location.host === 'dev.quipli.com' || window.location.host.includes('localhost')
      ? 'dev'
      : window.location.host === 'qa.quipli.com'
      ? 'qa'
      : window.location.host === 'integration.quipli.com'
      ? 'integration'
      : window.location.host === 'beta.quipli.com'
      ? 'beta'
      : tenant === 'gameready'
      ? 'hipaa'
      : 'prod';
  const [imageSrc, setImageSrc] = useState<string>(
    productId === 'placeholder'
      ? `https://quipli-service-${bucketEnv}-public.s3.amazonaws.com/${tenant}/products/placeholder/${
          profile ?? 'ORIGINAL'
        }`
      : `https://quipli-service-${bucketEnv}-public.s3.amazonaws.com/${tenant}/products/${productId}/images/defaults/${
          profile ?? 'ORIGINAL'
        }`,
  );

  const image = (
    <img
      loading="lazy"
      src={imageSrc}
      data-cy="product-image-v2"
      className={classNames(className)}
      onError={() =>
        setImageSrc(
          `https://quipli-service-${bucketEnv}-public.s3.amazonaws.com/${tenant}/products/placeholder/${
            profile ?? 'ORIGINAL'
          }`,
        )
      }
      alt={alt}
    />
  );

  return (
    <>
      {href ? (
        <a href={href} target="_blank" rel="noreferrer">
          {image}
        </a>
      ) : (
        image
      )}
    </>
  );
};
